import { IResponse } from "@core/data-access/model";
import { AbstractAccessorService, IDataAccessor } from "@core/data-access";


/**
 * @description 获取幂等key
 */
export class IdempotentKeyRestService extends AbstractAccessorService<string> {

    public readonly $name: string = "idempotentKeyRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<string>) {
        super();
    }
}